import type { TasPayment } from './tas-payment.type.ts';
export {
  PAYMENT_MANNERS,
  DEFAULT_PAYMENT_MANNER,
  PAYMENT_MANNER_LABEL_KEYS,
  type PaymentManner,
} from './tas-payment.type.ts';

export interface TasPaymentExtension extends TasPayment {}
export class TasPaymentExtension {
  // ── Computed Properties ──
  get isCreated() {
    return this.state === 'CREATED';
  }
}

const Registration = {
  kind: 'object',
  name: 'tas-payment',
  features: TasPaymentExtension,
};
export default Registration;
